export { default as FiberManualRecordIcon } from "@mui/icons-material/FiberManualRecord";
